<template>
  <Modal
    :model-value="modelValue"
    :title="title"
    :subtitle="subtitle"
    :icon="icon"
    :close-on-backdrop="closeOnBackdrop"
    :close-on-esc="closeOnEsc"
    :max-width="maxWidth"
    :full-screen="fullScreen"
    :close-disabled="closeDisabled"
    :mobile-sheet-expanded="mobileSheetExpanded"
    :z-index="zIndex"
    @update:model-value="emit('update:modelValue', $event)"
    @close="handleModalClose"
    @sheet-interaction="emit('sheet-interaction', $event)"
  >
    <template v-if="$slots.headerLeft" #headerLeft>
      <slot name="headerLeft" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <slot />
    <template #footer>
      <slot name="footer" />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from "@/components/modal/Modal.vue";
import type { ModalCloseReason } from "@/components/modal/modalCloseReason";

withDefaults(
  defineProps<{
    modelValue?: boolean;
    title?: string;
    subtitle?: string;
    icon?: string;
    closeOnBackdrop?: boolean;
    closeOnEsc?: boolean;
    maxWidth?: string;
    fullScreen?: boolean;
    closeDisabled?: boolean;
    mobileSheetExpanded?: boolean;
    /**
     * Опциональный z-index для оверлея. Передавать только когда нужно поднять модалку выше
     * другой модалки (например, при вложенном BalanceModal поверх full-screen CreateGoodDialog).
     */
    zIndex?: number;
  }>(),
  {
    modelValue: false,
    title: "Modal",
    subtitle: "",
    icon: "",
    closeOnBackdrop: true,
    closeOnEsc: true,
    maxWidth: "auto",
    fullScreen: false,
    closeDisabled: false,
    mobileSheetExpanded: false,
    zIndex: undefined,
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "close", reason?: ModalCloseReason): void;
  (e: "sheet-interaction", payload: { action: "expand" | "collapse" }): void;
}>();

/** Modal при наличии @close не шлёт update:modelValue — иначе v-model у родителя не сбрасывается (backdrop, Esc, крестик). */
function handleModalClose(reason?: ModalCloseReason) {
  emit("update:modelValue", false);
  emit("close", reason);
}
</script>
